(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scenes = new Map();
  const boot = (scope = document) => {
    scope.querySelectorAll('[data-uv27-motion]').forEach((art) => {
      if (scenes.has(art)) return;
      const control = art.querySelector('[data-uv27-play]');
      const buttons = [...art.querySelectorAll('[data-uv27-stage]')];
      const captions = [...art.querySelectorAll('[data-uv27-caption]')];
      const story = art.closest('.uv26-home,.uv26-hero');
      const track = story?.closest('[data-uv-story-track]');
      const events = new AbortController();
      const stages = ['idea','form','system'];
      let frame = 0, top = 80, step = 400, pinned = false, active = -1, holdFocus = false;
      const setStage = (index) => {
        const next = Math.max(0, Math.min(2, index));
        if (next === active) return;
        active = next;
        art.dataset.stage = stages[next];
        buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i === next)));
        captions.forEach(caption => caption.hidden = caption.dataset.uv27Caption !== stages[next]);
      };
      const update = () => {
        frame = 0;
        if (reduced.matches || document.hidden || !track) return;
        const distance = pinned ? top - track.getBoundingClientRect().top : innerHeight * .66 - art.getBoundingClientRect().top;
        const progress = Math.max(0, Math.min(1, distance / (step * 2.6)));
        if (!holdFocus || !art.contains(document.activeElement)) setStage(Math.floor(progress * 3));
        art.style.setProperty('--uv28-progress', String(progress));
      };
      const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
      const measure = () => {
        if (!track) return;
        top = Math.ceil(document.querySelector('[data-ura-header]')?.getBoundingClientRect().height || 68) + 8;
        const preview = document.getElementById('PBarNextFrame');
        const inset = preview ? Math.min(80, preview.getBoundingClientRect().height) : 0;
        const available = (window.visualViewport?.height || innerHeight) - top - inset;
        const height = story.getBoundingClientRect().height;
        pinned = !reduced.matches && available >= 500 && height <= available - 12;
        step = pinned ? Math.max(280, Math.min(600, available * .6)) : Math.max(120, innerHeight * .19);
        story.toggleAttribute('data-uv-pinned', pinned);
        story.style.setProperty('--uv28-top', top + 'px');
        const wanted = pinned ? Math.ceil(height + step * 3) + 'px' : '';
        if (track.style.height !== wanted) track.style.height = wanted;
        art.classList.toggle('uv27-settled', reduced.matches);
        if (reduced.matches) setStage(2); else queue();
      };
      buttons.forEach((button,index) => {
        button.disabled = false;
        button.addEventListener('click', () => {
          holdFocus = false;
          setStage(index);
          if (pinned) {
            const start = scrollY + track.getBoundingClientRect().top - top;
            scrollTo({top:Math.max(0,start + index * step + 5),behavior:'smooth'});
          }
        }, {signal:events.signal});
      });
      if (control) {
        if (control.contains(document.activeElement)) buttons[2]?.focus({preventScroll:true});
        control.hidden = true;
      }
      const resize = new ResizeObserver(measure);
      if (story) resize.observe(story);
      window.addEventListener('scroll',queue,{passive:true,signal:events.signal});
      window.addEventListener('resize',measure,{passive:true,signal:events.signal});
      window.addEventListener('pageshow',measure,{signal:events.signal});
      art.addEventListener('focusin',event=>{holdFocus=event.target.matches(':focus-visible');},{signal:events.signal});
      art.addEventListener('pointerdown',()=>{holdFocus=false;},{signal:events.signal});
      art.addEventListener('focusout',queue,{signal:events.signal});
      setStage(reduced.matches ? 2 : 0);
      measure();
      scenes.set(art, {
        settle: () => { cancelAnimationFrame(frame); frame = 0; },
        preference: measure,
        destroy: () => { cancelAnimationFrame(frame); resize.disconnect(); events.abort(); if (track) track.style.height = ''; story?.removeAttribute('data-uv-pinned'); scenes.delete(art); }
      });
    });
    scope.querySelectorAll('[data-ura-contact] form.ura-contact__form').forEach((form) => {
      if (form.dataset.uv26Inquiry) return;
      form.dataset.uv26Inquiry = 'true';
      const topic = form.querySelector('select[name="contact[Topic]"]');
      if (!topic) return;
      const panel = form.closest('.ura-contact__message');
      const message = form.querySelector('textarea[name="contact[body]"]');
      const defaultPlaceholder = message?.getAttribute('placeholder');
      const updateInquiry = () => {
        if (!panel) return;
        const studio = topic.selectedOptions[0]?.hasAttribute('data-uv26-topic') || false;
        panel.dataset.uv28Studio = String(studio);
        panel.querySelectorAll('[data-uv28-studio]').forEach((element) => {
          element.hidden = !studio;
          element.querySelectorAll('input,select,textarea').forEach((input) => { input.disabled = !studio; });
        });
        panel.querySelectorAll('[data-uv28-retail]').forEach((element) => { element.hidden = studio; });
        const order = form.querySelector('[data-ura-order-field]');
        if (order) { order.hidden = studio; order.querySelectorAll('input').forEach((input) => { input.disabled = studio; }); }
        if (message) {
          if (studio) message.setAttribute('placeholder', message.dataset.uv28Placeholder || '');
          else if (defaultPlaceholder !== null) message.setAttribute('placeholder', defaultPlaceholder);
          else message.removeAttribute('placeholder');
        }
      };
      topic.addEventListener('change', updateInquiry);
      if (new URLSearchParams(window.location.search).get('service') === 'ura-visual' && !topic.value) {
        const option = topic.querySelector('[data-uv26-topic]');
        if (option) { topic.value = option.value; topic.dispatchEvent(new Event('change', {bubbles:true})); }
      }
      updateInquiry();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), {once:true});
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => scenes.forEach((scene, element) => { if (event.target.contains(element)) scene.destroy(); }));
  document.addEventListener('visibilitychange', () => { if (document.hidden) scenes.forEach((scene) => scene.settle()); });
  reduced.addEventListener('change', () => scenes.forEach((scene) => scene.preference()));
})();

/* URA Visual page typography is owned by ura-visual-journey.css and follows the site-wide Changa Arabic system.
   The former page-level Arabic font injection (Alexandria / IBM Plex, ID-specific !important rules) was removed on 16 SEP 2026. */

/* Arabic typography and spacing authority for the URA Visual homepage entrance. */
(() => {
  const ensureFonts = () => {
    if (document.getElementById('ura-visual-arabic-fonts')) return;
    const preconnectGoogle = document.createElement('link');
    preconnectGoogle.rel = 'preconnect';
    preconnectGoogle.href = 'https://fonts.googleapis.com';
    document.head.append(preconnectGoogle);

    const preconnectStatic = document.createElement('link');
    preconnectStatic.rel = 'preconnect';
    preconnectStatic.href = 'https://fonts.gstatic.com';
    preconnectStatic.crossOrigin = 'anonymous';
    document.head.append(preconnectStatic);

    const fonts = document.createElement('link');
    fonts.id = 'ura-visual-arabic-fonts';
    fonts.rel = 'stylesheet';
    fonts.href = 'https://fonts.googleapis.com/css2?family=Alexandria:wght@400;500;600;700&family=IBM+Plex+Sans+Arabic:wght@400;500;600&display=swap';
    document.head.append(fonts);
  };

  const install = () => {
    const html = document.documentElement;
    const homes = document.querySelectorAll('[data-uv61-home]');
    if (!html.lang.toLowerCase().startsWith('ar') || !homes.length) return;
    ensureFonts();

    if (!document.getElementById('ura-visual-home-arabic-type')) {
      const style = document.createElement('style');
      style.id = 'ura-visual-home-arabic-type';
      style.textContent = `
html[lang^="ar"] body.ura-page .uv65-runway>.uv61-home{
  --uv-home-ar-display:'Alexandria',Tahoma,Arial,sans-serif;
  --uv-home-ar-text:'IBM Plex Sans Arabic',Tahoma,Arial,sans-serif;
  font-family:var(--uv-home-ar-text)!important;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__copy{
  max-width:540px;
  justify-self:start;
  text-align:start;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__logo{
  display:flex!important;
  justify-content:flex-start!important;
  direction:rtl;
  margin-bottom:2px;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__logo .uv26-lockup{
  direction:ltr!important;
  margin-inline-start:0!important;
  margin-inline-end:auto!important;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home h2{
  font-family:var(--uv-home-ar-display)!important;
  font-weight:600!important;
  font-size:clamp(39px,3.9vw,58px)!important;
  line-height:1.11!important;
  letter-spacing:0!important;
  max-width:13.2ch!important;
  margin:18px 0 14px!important;
  text-wrap:balance;
  text-rendering:optimizeLegibility;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home h2>span{
  display:block!important;
  color:var(--ura-color-basalt)!important;
  margin-top:.08em;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__copy>p{
  font-family:var(--uv-home-ar-text)!important;
  font-weight:400!important;
  font-size:13.5px!important;
  line-height:1.78!important;
  letter-spacing:0!important;
  max-width:38ch!important;
  color:var(--ura-color-basalt)!important;
}
html[lang^="ar"] body.ura-page .uv65-runway :is(.uv61-home__top,.uv61-home__bottom){
  font-family:var(--uv-home-ar-text)!important;
  font-weight:500!important;
  letter-spacing:0!important;
  line-height:1.55!important;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__enter{
  font-family:var(--uv-home-ar-text)!important;
  font-weight:500!important;
  font-size:12.5px!important;
  letter-spacing:0!important;
  margin-top:17px!important;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__enter>span{
  padding-inline:23px!important;
}
html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__logo .uv26-lockup__word{
  font-family:'URA Visual Sora',Inter,Arial,sans-serif!important;
  direction:ltr!important;
}
@media(min-width:801px){
  html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__grid{
    grid-template-columns:minmax(0,.96fr) minmax(0,1.04fr)!important;
    gap:42px!important;
  }
}
@media(max-width:800px){
  html[lang^="ar"] body.ura-page .uv65-runway .uv61-home h2{
    font-size:clamp(31px,8.5vw,43px)!important;
    line-height:1.13!important;
    max-width:14.2ch!important;
    margin:13px 0 10px!important;
  }
  html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__copy>p{
    font-size:12.5px!important;
    line-height:1.72!important;
    max-width:40ch!important;
  }
  html[lang^="ar"] body.ura-page .uv65-runway .uv61-home__enter{
    font-size:11.5px!important;
    margin-top:12px!important;
  }
}
@media(max-width:390px){
  html[lang^="ar"] body.ura-page .uv65-runway .uv61-home h2{
    font-size:clamp(29px,8.2vw,37px)!important;
    max-width:15ch!important;
  }
}
      `;
      document.head.append(style);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, {once:true});
  else install();
  document.addEventListener('shopify:section:load', install);
})();
